import { DBDeliveryTypes } from '@prisma/client';
import api from '@tyrio/api-factory';
import { DBDeliveryTypesApi } from '@tyrio/dto';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { SelectAllHeader } from '../components/SelectAllHeader';
import { SwitchCard } from '../components/SwitchCard';
import {
  handleActive,
  handleAllActive,
} from '../helpers/handle-active-methods';
import { CardsWrapper } from './CommonStyle';

interface DeliveryMethodsBranchTabProps {
  setPayloadShape: Dispatch<SetStateAction<Record<string, boolean>>>;
  selectedDeliveries?: Record<string, boolean>;
}

export const DeliveryMethodsBranchTab = ({
  setPayloadShape,
  selectedDeliveries,
}: DeliveryMethodsBranchTabProps) => {
  const [deliveryMethods, setDeliveryMethods] = useState<DBDeliveryTypes[]>([]);
  const [isActive, setIsActive] = useState<Record<string, boolean>>(
    selectedDeliveries ?? {}
  );
  const [areAllActive, setAreAllActive] = useState(false);

  useQuery(
    ['get_client_delivery_types'],
    async () => {
      return await api.fetch<DBDeliveryTypesApi['list']>(
        'get_client_delivery_types'
      );
    },
    {
      onSuccess: (data) => {
        setDeliveryMethods(data.filter((item) => item.isActive === true));
      },
    }
  );

  useEffect(() => {
    setPayloadShape(isActive);
  }, [isActive, setPayloadShape]);

  return (
    <div>
      <SelectAllHeader
        text={'Assign available delivery methods'}
        onClick={() =>
          handleAllActive(
            isActive,
            setIsActive,
            areAllActive,
            setAreAllActive,
            deliveryMethods
          )
        }
      />
      <CardsWrapper>
        {deliveryMethods.length > 0 &&
          deliveryMethods.map((item) => (
            <SwitchCard
              key={item.id}
              name={item.name}
              description={item.description ?? ''}
              onClick={() =>
                handleActive(item.id, setIsActive, setAreAllActive)
              }
              isActive={isActive[item.id]}
            />
          ))}
      </CardsWrapper>
    </div>
  );
};
